export default __webpack_public_path__ + "c079abf4096e55179d835841238df28c.json";